import React from 'react';
import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

import OktetoLogo from '../assets/logo-horizontal-darkbg.svg';
import YCLogoImage from '../assets/logos/logo-ycombinator.svg';
import Soc2Logo from '../assets/logos/logo-soc2.webp';

import HubspotForm from '../components/HubspotForm';

import './Footer.scss';

function Footer() {
  return (
    <footer className="Footer">
      <div className="FooterContainer">
        <div className="FooterHeader">
          <Link to="/" aria-label="Homepage">
            <OktetoLogo className="FooterLogo" />
          </Link>
          <div className="FooterFormContainer">
            <h4>Subscribe to our newsletter</h4>
            <HubspotForm
              formId="832002da-f018-426d-8b6f-45ac98caaf06"
              dontUseChiliPiper
            />
          </div>
        </div>
        <div className="FooterLinks">
          <div>
            <h4>Company</h4>
            <ul>
              <li>
                <Link to="/about-us/">About us</Link>
              </li>
              <li>
                <a href="/customers/">Customers</a>
              </li>
              <li>
                <Link to="/pricing/">Pricing</Link>
              </li>
              <li>
                <Link to="/legal/">Legal</Link>
              </li>
              <li>
                <Link to="/privacy-policy/">Privacy</Link>
              </li>
            </ul>
          </div>
          <div>
            <h4>Docs</h4>
            <ul>
              <li>
                <a href="/docs/get-started/install-okteto-cli/">
                  Get started with Okteto CLI
                </a>
              </li>
              <li>
                <a href="/docs/get-started/overview/">Install Okteto</a>
              </li>
              <li>
                <a href="/docs/manifest/overview-manifest/">Okteto Manifest</a>
              </li>
              <li>
                <a href="/docs/guides/samples/golang/">Samples</a>
              </li>
              <li>
                <a href="/docs/release-notes/">Release Notes</a>
              </li>
            </ul>
          </div>
          <div>
            <h4>Resources</h4>
            <ul>
              <li>
                <Link to="/blog/">Blog</Link>
              </li>
              <li>
                <Link to="/product-tour-center/">Demo Center</Link>
              </li>
              <li>
                <Link to="/videos/">Videos</Link>
              </li>
              <li>
                <OutboundLink href="https://community.okteto.com">
                  Community Forum
                </OutboundLink>
              </li>
              <li>
                <Link to="/devx-all-day/">DevX All Day</Link>
              </li>
            </ul>
          </div>
          <div>
            <h4>Contact Us</h4>
            <ul className="contact-us">
              <li>
                <Link to="/contact/">Talk to an expert</Link>
              </li>
              <li>
                <a href="https://support.okteto.com/hc/en-us">Support</a>
              </li>
              <li className="layout horizontal center">
                <svg
                  viewBox="0 0 64 64"
                  width="1em"
                  height="1em"
                  aria-hidden="true"
                >
                  <path
                    fill="white"
                    d="M58,15.8769531c-1.939846,0.8125-3.889843,1.4624996-6.1546898,1.625 c2.264843-1.3000011,3.889843-3.4023438,4.702343-5.8296881c-2.1023445,1.3000011-4.3773422,2.1023445-6.8046875,2.5898438 c-1.7773438-2.1023436-4.7023392-3.4023438-7.6171875-3.4023438c-5.8296852,0-10.6945305,4.7023439-10.6945305,10.6945333 c0,0.8125,0.1625023,1.625,0.3250008,2.4273415c-8.9070301-0.4874992-16.686718-4.702343-22.028904-11.1820297 c-0.9750004,1.625-1.4625006,3.4023438-1.4625006,5.342186c0,3.7273445,1.9398441,6.9671879,4.7023439,8.907032 c-1.7773438,0-3.4023438-0.4875011-4.8648434-1.3000011v0.1625004c0,5.1796875,3.7273436,9.3945312,8.5820303,10.3695335 c-0.9749994,0.1624985-1.7773428,0.3250008-2.7523432,0.3250008c-0.6499996,0-1.3000002,0-1.9398432-0.1625023 c1.3000002,4.2148438,5.342186,7.2921867,9.8820305,7.454689c-3.5648422,2.9148445-8.2570305,4.5398445-13.2843742,4.5398445 c-0.8125,0-1.7773438,0-2.5898438-0.1625023c4.702343,3.077343,10.3695316,4.8648453,16.3617191,4.8648453 c19.6015606,0,30.2960911-16.1992188,30.2960911-30.296093c0-0.4875011,0-0.9750004,0-1.3000011 C54.7601585,19.7566395,56.547657,17.9792976,58,15.8769531z"
                  ></path>
                </svg>
                <OutboundLink href="https://twitter.com/oktetohq">
                  Twitter
                </OutboundLink>
              </li>
            </ul>
          </div>
        </div>

        <div className="FooterLogos">
          <div className="soc2">
            <img
              src={Soc2Logo}
              width={100}
              height={100}
              alt="Soc 2"
              loading="lazy"
            />
            SOC2 Type 2 Compliant
          </div>
          <div className="ycombinator">
            Part of the
            <OutboundLink href="https://www.ycombinator.com/">
              <YCLogoImage width="155" height="28" />
            </OutboundLink>
            family.
          </div>
        </div>

        <div className="copyright layout horizontal center-center">
          © Copyright Okteto Inc {new Date().getFullYear()}. All rights
          reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
